// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';


var apiKey = "dc6zaTOxFJmzC";

exports.apiKey = apiKey;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/config.re
// module id = 45
// module chunks = 0